import * as Api from '@Api/index';
import { BackendError } from '@Common/errors';

import type { KitProductData } from '@Types/Kit';

export interface Response {
  ok: boolean;
  data: KitProductData;
}

async function getKitProducts(id: number, page?: number) {
  const params = new URLSearchParams({ shopProductId: id.toString(), page: page?.toString() });
  const url = '/backend/shop-product/get-kit-products';
  const res = await Api.queryProxi<Response>(`${url}?${params.toString()}`);

  if (!res.ok) throw new BackendError(url, res);

  return res.data;
}

export default getKitProducts;
